import React, { ReactNode, RefObject } from "react";
import useScrollShadow from "src/hooks/useScrollShadow";

const ScrollShadowProvider = ({
  children,
  tableRef,
  className,
  isShowScrollShadow = true,
}: {
  children: ReactNode;
  tableRef?: RefObject<any>;
  className?: string;
  isShowScrollShadow?: boolean;
}) => {
  useScrollShadow(isShowScrollShadow ? tableRef : undefined);
  return <div className={`base-table-scroll-warp ${className ? className : ""}`}>{children}</div>;
};

export default ScrollShadowProvider;
